import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root',
})
export class BaseHttpService {
  protected httpClient = inject(HttpClient);
  private loadingService = inject(LoadingService);

  protected withLoader<T>(obs$: Observable<T>): Observable<T> {
    return new Observable<T>((observer) => {
      this.loadingService.show();
      const subscription = obs$
        .pipe(
          finalize(() => {
            this.loadingService.hide();
          })
        )
        .subscribe({
          next: (value) => observer.next(value),
          error: (err) => observer.error(err),
          complete: () => observer.complete(),
        });
      return () => subscription.unsubscribe();
    });
  }
}
